function AssessGroupLearner(props) {

  // Define variables
  const viewCode = props.viewCode;
  const headings = props.headings;
  const learner = props.learner;
  const rowWidth = props.rowWidth;


  // Screen components
  let bodyElement = [<div class='first-name' key={`learner-assessment-first`}>{learner.firstName}</div>];

  headings.map((heading, index) => {

    if( heading.core ) {
      const cefr = learner[`${heading.name}-cefr`];
      const score = learner[`${heading.name}-score`];
      const assessmentId = learner[`${heading.name}-assessmentId`];

      if( cefr ) {
        bodyElement.push(
          <div class='flex-row inner' key={`learner-assessment-${index}`}>

            <span class='flex-row'>
              {cefr}
              &nbsp;
              <small>({score}/100)</small>
            </span>

            <button
              onClick={() => viewCode({assessmentId: assessmentId})}
              class='icon icon-view-fill'
              title='View'
            />

          </div>
        );
      } else {
        bodyElement.push(<div class='inner' key={`learner-assessment-${index}`}>&nbsp;</div>);
      }
    }
  });

  // Add the delta
  bodyElement.push(
    <div class='delta' key={`learner-delta`}>
      {Math.sign(learner.delta) === 1 ? "+" : null}
      {learner.delta}
    </div>
  );


  return (
    <div class='flex-row assess-groupd-row' key={`grouped-row-${learner.id}`} style={{width: rowWidth}}>
      {bodyElement}
    </div>
  );
}

export default AssessGroupLearner;